var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.34984 12C2.07206 12 1.83595 11.9028 1.6415 11.7083C1.44706 11.5139 1.34984 11.2778 1.34984 11V1.5H0.666504V0.5H3.79984V0H8.19984V0.5H11.3332V1.5H10.6498V11C10.6498 11.2667 10.5498 11.5 10.3498 11.7C10.1498 11.9 9.9165 12 9.64984 12H2.34984ZM9.64984 1.5H2.34984V11H9.64984V1.5ZM4.1165 9.56667H5.1165V2.91667H4.1165V9.56667ZM6.88317 9.56667H7.88317V2.91667H6.88317V9.56667ZM2.34984 1.5V11V1.5Z",
    fill: "#E13E3E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/deleteIcon.56ba7b441227c3bf8156486901146ff7.svg";
export { ForwardRef as ReactComponent };